import { http } from '@/utils/http';
import qs from 'qs';


// 获取评论
export function getComment() {
  return http.get('//voteone.cqcb.com/vote/2019poject/2019advancing/controller.php?enews=comment-list');
}

// 提交评论
export function saveComment(data?: any) {
  const qsData = qs.stringify(data);
  return http.post(
    '//voteone.cqcb.com/vote/2019poject/2019advancing/controller.php?enews=comment-save',
    qsData,
  );
}

export function getnewslist( name: string, page: number) {
  return http.get(
      '//voteone.cqcb.com/vote/2019poject/2019advancing/controller.php?enews=' + name + '&page=' + page,
    );
}

